/* KATANA native custom options - step-wizard flow, add-on pricing, multi-line cart add.
   Port of the BadmintonPeople bp-options.js engine, adapted to the Impulse theme:
   - form: form[id^="AddToCartForm"]; variant id from its select[name="id"]
   - intercepts [data-add-to-cart] clicks in capture phase (also catches the
     sticky-bar proxy click) so Impulse's own AJAX add never runs for this form
   - after success: dispatches 'ajaxProduct:added' so the Impulse cart drawer
     rebuilds and opens natively (or redirects when cart type is 'page')
   Optional labor products: stringing / four-knot / grip-service ids may be null
   in the config; groups without a product are free (no add-on line). */
(function () {
  if (window.__koOptionsInit) return;
  window.__koOptionsInit = true;

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
    } catch (e) {}
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function init() {
    var root = document.querySelector('[data-ko-options]');
    if (!root || root.__koInit) return;
    root.__koInit = true;

    var sectionEl = root.closest('[data-section-type="product"]') || document;
    var form = sectionEl.querySelector('form[id^="AddToCartForm"]');
    var cfgEl = root.querySelector('[data-ko-opt-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
    if (!form || !cfg) return;

    var variantsEl = root.querySelector('[data-ko-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idSelect = form.querySelector('select[name="id"], input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + form.id + '"]');

    var hasFourKnot = !!(cfg.fourKnot && cfg.fourKnot.id);
    var productTitle = (sectionEl.getAttribute && sectionEl.getAttribute('data-product-title')) || document.title;

    var state = {
      frame: 'Unstrung', string: null, stringTitle: null, stringColor: null,
      tension: null, method: 'Two Knots',
      grip: 'Not Required', gripType: null, gripTypeTitle: null, gripColor: null
    };

    /* ---------- wizard model ---------- */
    var CHAIN = ['frame', 'string', 'stringColor', 'tension', 'method', 'grip', 'gripType', 'gripColor'];
    var LABELS = { frame: 'Frame', string: 'String', stringColor: 'String colour', tension: 'Tension', method: 'Method', grip: 'Grip', gripType: 'Grip choice', gripColor: 'Grip colour' };
    var answered = {};
    var openGroup = 'frame';

    function relevant(name) {
      switch (name) {
        case 'string': case 'tension': return state.frame === 'Strung';
        case 'method': return state.frame === 'Strung' && hasFourKnot;
        case 'stringColor': return state.frame === 'Strung' && !!state.string;
        case 'gripType': return state.grip === 'Required';
        case 'gripColor': return state.grip === 'Required' && !!state.gripType;
        default: return true;
      }
    }

    function answerText(name) {
      switch (name) {
        case 'frame': return state.frame;
        case 'string': return state.stringTitle || '';
        case 'stringColor': return state.stringColor ? state.stringColor.title : '';
        case 'tension': return state.tension || '';
        case 'method': return state.method;
        case 'grip': return state.grip;
        case 'gripType': return state.gripTypeTitle || '';
        case 'gripColor': return state.gripColor ? state.gripColor.title : '';
      }
      return '';
    }

    function group(name) { return root.querySelector('[data-opt-group="' + name + '"]'); }

    function nextUnanswered() {
      for (var i = 0; i < CHAIN.length; i++) {
        var n = CHAIN[i];
        if (relevant(n) && !answered[n] && group(n)) return n;
      }
      return null;
    }

    /* inject collapsed-summary buttons once */
    CHAIN.forEach(function (name) {
      var g = group(name);
      if (!g || g.querySelector('[data-opt-reopen]')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ko-opt__done';
      btn.setAttribute('data-opt-reopen', name);
      btn.hidden = true;
      g.insertBefore(btn, g.firstChild);
    });

    function showColorsFor(groupName, handle) {
      var g = group(groupName);
      if (!g) return;
      g.querySelectorAll('[data-opt-colors-for]').forEach(function (c) {
        c.hidden = c.getAttribute('data-opt-colors-for') !== handle;
      });
    }

    function clearActive(name) {
      var g = group(name);
      if (g) g.querySelectorAll('.ko-chip').forEach(function (c) { c.classList.remove('ko-chip--active'); });
    }

    function render(focusOpened) {
      CHAIN.forEach(function (name) {
        var g = group(name);
        if (!g) return;
        var isRelevant = relevant(name);
        g.hidden = !isRelevant;
        if (!isRelevant) return;
        var done = g.querySelector('[data-opt-reopen]');
        var isOpen = openGroup === name;
        var isAnswered = !!answered[name];
        g.classList.toggle('ko-opt__group--collapsed', !isOpen && isAnswered);
        g.classList.toggle('ko-opt__group--open', isOpen);
        if (done) {
          done.hidden = !(isAnswered && !isOpen);
          if (isAnswered) {
            done.innerHTML = '<span class="ko-opt__done-label">' + LABELS[name].toUpperCase() + '</span><b>' + answerText(name) + '</b><span class="ko-opt__done-change">Change</span>';
          }
        }
        /* unanswered + not open: waiting its turn - keep hidden */
        if (!isAnswered && !isOpen) g.hidden = true;
        if (isOpen) {
          g.classList.remove('ko-opt__group--enter');
          void g.offsetWidth;
          g.classList.add('ko-opt__group--enter');
        }
      });
      var note = root.querySelector('[data-opt-cod-note]');
      if (note) note.hidden = state.frame !== 'Strung';
      if (focusOpened && openGroup) {
        var og = group(openGroup);
        if (og) setTimeout(function () { og.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
      }
    }

    /* ---------- pricing ---------- */
    function addons() {
      var list = [];
      if (state.frame === 'Strung') {
        if (cfg.stringing && cfg.stringing.id) list.push({ id: cfg.stringing.id, price: cfg.stringing.price, field: 'Stringing Service' });
        if (state.stringColor) list.push({ id: state.stringColor.id, price: state.stringColor.price, field: state.stringTitle + ' Color' });
        if (hasFourKnot && state.method === 'Four Knots') list.push({ id: cfg.fourKnot.id, price: cfg.fourKnot.price, field: 'Stringing Method' });
      }
      if (state.grip === 'Required') {
        if (cfg.gripSvc && cfg.gripSvc.id) list.push({ id: cfg.gripSvc.id, price: cfg.gripSvc.price, field: 'Grip Service' });
        if (state.gripColor) list.push({ id: state.gripColor.id, price: state.gripColor.price, field: state.gripTypeTitle + ' Color' });
      }
      return list;
    }

    function optionsTotal() {
      return addons().reduce(function (s, a) { return s + a.price; }, 0);
    }

    function qty() { return parseInt(qtyInput ? qtyInput.value : '1', 10) || 1; }

    function currentVariant() {
      if (!variants.length) return null;
      var id = idSelect ? parseInt(idSelect.value, 10) : null;
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }

    function syncTotals() {
      var extra = optionsTotal();
      var summary = root.querySelector('[data-opt-summary]');
      if (summary) {
        summary.hidden = extra === 0;
        var st = summary.querySelector('[data-opt-total]');
        /* theme.Currency.formatMoney returns HTML (<span class=money>...) - strip tags */
        if (st) st.textContent = '+' + String(money(extra)).replace(/<[^>]*>/g, '').trim();
      }
    }

    function validate() {
      if (state.frame === 'Strung') {
        if (!state.string) return 'Choose a string for your strung racket.';
        if (!state.stringColor) return 'Choose a string colour.';
        if (!state.tension) return 'Choose a stringing tension.';
      }
      if (state.grip === 'Required') {
        if (!state.gripType) return 'Choose a grip.';
        if (!state.gripColor) return 'Choose a grip colour.';
      }
      return null;
    }

    function showError(msg) {
      var el = root.querySelector('[data-opt-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
      if (msg) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    /* ---------- clicks: chips + reopen + filter pills ---------- */
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-ko-pill]');
      if (pill) {
        var pg = pill.closest('[data-opt-group]');
        if (pg) {
          pg.querySelectorAll('[data-ko-pill]').forEach(function (p) { p.classList.remove('ko-pill--active'); });
          pill.classList.add('ko-pill--active');
          var val = (pill.getAttribute('data-ko-pill') || 'all').toLowerCase();
          pg.querySelectorAll('[data-opt][data-tags]').forEach(function (c) {
            var tags = (c.getAttribute('data-tags') || '').toLowerCase().split(',');
            c.hidden = val !== 'all' && tags.indexOf(val) === -1;
          });
        }
        return;
      }

      var reopen = e.target.closest('[data-opt-reopen]');
      if (reopen) {
        openGroup = reopen.getAttribute('data-opt-reopen');
        render(true);
        return;
      }

      var chip = e.target.closest('[data-opt]');
      if (!chip || chip.disabled) return;
      var opt = chip.getAttribute('data-opt');

      if (opt === 'frame') {
        var was = state.frame;
        state.frame = chip.getAttribute('data-value');
        if (state.frame !== was) {
          state.string = null; state.stringTitle = null; state.stringColor = null; state.tension = null; state.method = 'Two Knots';
          ['string', 'stringColor', 'tension', 'method'].forEach(function (n) { answered[n] = false; clearActive(n); });
        }
      } else if (opt === 'string') {
        if (state.string !== chip.getAttribute('data-handle')) { state.stringColor = null; answered.stringColor = false; clearActive('stringColor'); }
        state.string = chip.getAttribute('data-handle');
        state.stringTitle = chip.getAttribute('data-title');
        showColorsFor('stringColor', state.string);
      } else if (opt === 'stringColor') {
        state.stringColor = { id: parseInt(chip.getAttribute('data-variant-id'), 10), price: parseInt(chip.getAttribute('data-price'), 10), title: chip.getAttribute('data-value') };
      } else if (opt === 'tension') {
        state.tension = chip.getAttribute('data-value');
      } else if (opt === 'method') {
        state.method = chip.getAttribute('data-value');
      } else if (opt === 'grip') {
        var wasG = state.grip;
        state.grip = chip.getAttribute('data-value');
        if (state.grip !== wasG) {
          state.gripType = null; state.gripTypeTitle = null; state.gripColor = null;
          ['gripType', 'gripColor'].forEach(function (n) { answered[n] = false; clearActive(n); });
        }
      } else if (opt === 'gripType') {
        if (state.gripType !== chip.getAttribute('data-handle')) { state.gripColor = null; answered.gripColor = false; clearActive('gripColor'); }
        state.gripType = chip.getAttribute('data-handle');
        state.gripTypeTitle = chip.getAttribute('data-title');
        showColorsFor('gripColor', state.gripType);
      } else if (opt === 'gripColor') {
        state.gripColor = { id: parseInt(chip.getAttribute('data-variant-id'), 10), price: parseInt(chip.getAttribute('data-price'), 10), title: chip.getAttribute('data-value') };
      }

      var g = chip.closest('.ko-opt__chips');
      if (g) g.querySelectorAll('.ko-chip').forEach(function (c) { c.classList.remove('ko-chip--active'); });
      chip.classList.add('ko-chip--active');

      /* this group is answered - collapse it and open the next step */
      var groupName = chip.closest('[data-opt-group]').getAttribute('data-opt-group');
      answered[groupName] = true;
      openGroup = nextUnanswered();
      showError(null);
      render(true);
      syncTotals();
    });

    /* ---------- line item properties ---------- */
    function parentProperties(groupId) {
      var p = { '_ko_group': groupId, 'Frame': state.frame };
      if (state.frame === 'Strung') {
        p['String selection'] = state.stringTitle;
        p[state.stringTitle + ' Color'] = state.stringColor ? state.stringColor.title : '';
        p['Tension'] = state.tension;
        if (hasFourKnot) p['Stringing Method'] = state.method;
      }
      p['Grip'] = state.grip;
      if (state.grip === 'Required') {
        p['Select Grip'] = state.gripTypeTitle;
        p[state.gripTypeTitle + ' Color'] = state.gripColor ? state.gripColor.title : '';
      }
      return p;
    }

    var busy = false;
    function addAllToCart(trigger) {
      if (busy) return;
      var err = validate();
      if (err) {
        showError(err);
        openGroup = nextUnanswered();
        render(true);
        return;
      }
      var v = currentVariant();
      if (!v) { showError('Could not resolve the selected variant - refresh and try again.'); return; }
      var extras = addons();
      var bad = extras.find(function (a) { return !a.id; });
      if (bad) { showError('Option "' + bad.field + '" is misconfigured (missing product) - please contact support.'); return; }
      busy = true;
      var groupId = String(Date.now()) + Math.floor(Math.random() * 1e4);
      var q = qty();
      var items = [{ id: v.id, quantity: q, properties: parentProperties(groupId) }];
      extras.forEach(function (a) {
        /* visible marker so backend/packing slips clearly show this line is part
           of a racket customization, not a standalone purchase */
        items.push({ id: a.id, quantity: q, properties: {
          'Customisation for': productTitle,
          'Applied as': a.field,
          '_ko_parent_group': groupId,
          '_ko_field': a.field
        } });
      });
      if (window.console) console.log('[katana-options] adding to cart:', JSON.stringify(items));
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn) { addBtn.classList.add('btn--loading'); addBtn.setAttribute('disabled', 'disabled'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) {
            if (!r.ok) {
              var msg = (data && (data.description || data.message)) || ('Cart error (' + r.status + ')');
              if (window.console) console.error('[katana-options] cart add failed:', r.status, data);
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function (data) {
          if (window.theme && theme.settings && theme.settings.cartType === 'page') {
            window.location.href = '/cart';
            return;
          }
          /* "Added to cart" feedback on the button */
          var txt = addBtn && addBtn.querySelector('[data-add-to-cart-text]');
          if (txt) {
            var orig = txt.getAttribute('data-default-text') || txt.textContent;
            txt.textContent = 'Added to cart ✓';
            setTimeout(function () { txt.textContent = orig; }, 2200);
          }
          /* update the header cart count bubble directly */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.innerText = cart.item_count; });
              document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
                b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
              });
            })
            .catch(function () {});
          /* Impulse CartDrawer listens on document: rebuilds the cart + opens the drawer */
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: trigger || addBtn },
            bubbles: true
          }));
        })
        .catch(function (e2) { showError(e2 && e2.message ? e2.message : 'Could not add to cart - please try again.'); })
        .finally(function () {
          busy = false;
          if (addBtn) { addBtn.classList.remove('btn--loading'); addBtn.removeAttribute('disabled'); }
        });
    }

    /* Intercept at click level (capture phase beats the theme's listeners), so
       Impulse's own AJAX add never runs for this form. Submit capture kept as a
       backstop for Enter-key submits. */
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-to-cart]');
      if (add && form.contains(add)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addAllToCart(add);
      }
    }, true);

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addAllToCart(null);
    }, true);

    render(false);
    syncTotals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
